import { Select as AntdSelect } from 'antd'
import { SelectProps } from 'antd/lib'

import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  width?: number | string
  placeholder?: string | React.ReactNode
} & SelectProps

export const Select = ({ width, placeholder, ...props }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles({ width })

  return (
    <AntdSelect
      className={styles.select}
      placeholder={placeholder ?? t('common.sort_by')}
      popupMatchSelectWidth={false}
      placement="bottomRight"
      dropdownAlign={{ points: ['t', 'b'] }}
      {...props}
    />
  )
}
